import { Box, FormLabel, Select, SelectProps } from '@chakra-ui/react'

interface iFormProps extends SelectProps {
  title?: string
  value?: string
  OnChange: (e: string) => void
  isInvalid?: boolean
  mb?: string
  isDisabled?: boolean
  fontSize?: string
}

export const SelectCmp: React.FC<iFormProps> = ({ children, OnChange, title, value, w, h, width, isInvalid, mb, isDisabled, fontSize, minW }) => {
  return (
    <Box w={w} width={width} mb={mb} cursor={isDisabled ? 'not-allowed' : ''}>
      {title && <FormLabel color={'var(--Gray1)'} fontSize={'14px'} mb={'.25rem'}>{title}</FormLabel>}
      <Select isInvalid={isInvalid} isDisabled={isDisabled} onChange={(e) => OnChange(e.target.value)} value={value} bg={'white'} borderColor={'var(--Gray4)'} size='xs' h={h ?? '1.975rem'} fontSize={fontSize ?? '.875rem'} w={width} minW={minW}>
        {children}
      </Select>
    </Box>
  )
}
